import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setActive } from '../store/StaticMapStore';
import Menu from '../components/Menu';
import config from '../config';
import './StaticMap.css';
import './Documents.css';



const StaticMap = () => {
    const dispatch = useDispatch();
    const staticMaps = useSelector((state) => state.staticMapState.staticMaps);
    const activeStaticMap = useSelector((state) => state.staticMapState.activeStaticMap);

    const handleSetActive = (staticMap) => {
        dispatch(setActive(staticMap));
    };

    return (
        <div className="App">
            <Menu />
            <div className='maps'>
                <div className='maps-container'>
                    {staticMaps && staticMaps.map((staticMap, index) => (
                        <div
                            key={index}
                            onClick={() => handleSetActive(staticMap)}
                            className={`map ${activeStaticMap && staticMap.id === activeStaticMap.id ? 'active' : ''}`}
                        >
                            {staticMap.name}
                        </div>
                    ))}
                </div>
                {activeStaticMap && (
                    <div className='static-map'>
                        <img src={activeStaticMap.map} alt={activeStaticMap.name} />
                        {/**
                        <img src={`/static/media/images/${activeStaticMap.path}`} alt={activeStaticMap.name}/>
                        */}
                    </div>
                )}
            </div>
        </div>
    );
};

export default StaticMap;